import { useCallback, useEffect, useState } from 'react';
import { ClassesData, rpc } from './api';

/** A school's year, grade levels, sections, classes and teachers. */
export function useClasses(schoolId: string, enabled = true): [ClassesData | null, () => Promise<void>] {
  const [data, setData] = useState<ClassesData | null>(null);
  const load = useCallback(async () => {
    // Classes are inside the school: only loaded in support mode (0010).
    if (!enabled) return;
    const r = await rpc<ClassesData>('platform_school_classes', { p_school_id: schoolId });
    if (r.data) setData(r.data);
  }, [schoolId, enabled]);
  useEffect(() => {
    load();
  }, [load]);
  return [data, load];
}

